import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';
import { Label } from "@progress/kendo-react-labels";
import { toInteger } from 'lodash';
import React, { FunctionComponent } from 'react'
import { ClientApi } from '../../../redux/api/ClientApi';

const ClientFieldList: FunctionComponent<FieldRenderProps> = props => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    value,
    data,
    multiSelect,
    field,
    ...others
  } = props;
  const values = Array.isArray(field?.VALUES) ? field?.VALUES?.map(v => toInteger(v)) : [];
  const clientTypeId = field?.ConfigSettings?.ClientType;
  const { data: clients } = ClientApi.useGetClientListQuery(clientTypeId);
  //const defaultClient = clients?.filter(c=>c.ID == defaultValue);
  //const defaultClients = clients?.filter(c=>defaultValue.split(',').indexOf(c.ID.toString()) > -1);
  const currentValues = values?.length > 0 ? clients?.filter(i => values?.indexOf(i.ID) > -1) : undefined;
  const fieldChanged = (e) => {
    let fieldChange = { ...field, VALUES: [e.value.ID] }
    props.onChange({ value: fieldChange });
  }
  const multiFieldChanged = (e) => {
    let newValues = e.value.length ? e.value : [{ ID: null }];//Null required to remove existing values from multi-select
    let fieldChange = { ...field, VALUES: newValues.map(v => v.ID) }

    props.onChange({ value: fieldChange });
  }
  const listControl = () => {
    if (field?.ConfigSettings?.Display === '1' || multiSelect)
      return <MultiSelect {...others} popupSettings={{ className: "z500" }} placeholder='Select multiple' onChange={multiFieldChanged} value={currentValues} data={clients} textField="Company_Name" dataItemKey='ID' />
    else
      return <DropDownList {...others} popupSettings={{ className: "z500" }} defaultItem={{ Company_Name: "Select" }} onChange={fieldChanged} value={currentValues?.length > 0 ? currentValues[0] : undefined} data={clients} dataItemKey="ID" textField="Company_Name" />
  }
  return (
    <>
      <Label
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
      >
        {label}
      </Label>
      {listControl()}
    </>
  )
}

export default ClientFieldList;